import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { Modal } from "@mui/material";
import CategorySelector from "../../../components/stats/CategorySelector";
import DateRangeSelector from "../../../components/stats/DateRangeSelector";
import SubTypeStatsList from "../../../components/stats/SubTypeStatsList";
import SuggestionTrackerTable from "../../../components/usage/SuggestionTrackerTable";
import useUsageTracker, { DateRange } from "../../../hooks/usage/useUsageTracker";
import { useState } from "react";
import { UsageTrackingEntry } from "../../../interfaces/usage";

export default function SuggestionsStats() {
  const {
    trackingEntries,
    loading,
    error,
    loadTrackingEntries,
    page,
    setPage,
    hasMore,
    totalEntries,
    changeYear,
    changeMonth,
    setFromDay,
    setToDay,
    fromDay,
    toDay,
    fromYear,
    toYear,
    fromMonth,
    toMonth,
    fromMonthDays,
    toMonthDays,
    loadTrackingEntriesByDateRange,
    isDateChanged,
    setIsDateChanged,
    exportLoading,
    exportError,
    loadTrackingEntriesExport,
    csvData,
    selectedCategory,
    handleCategoryChange,
    subTypeStats,
    loadSuggestionsEntriesStatsByDateRange
  } = useUsageTracker(true);
  const [selectedEntry, setSelectedEntry] = useState<UsageTrackingEntry | null>(null);

  const handleDateChange = (fromDate: Date, toDate: Date) => {
    setFromDay(fromDate.getDate());
    setToDay(toDate.getDate());
    changeYear(fromDate.getFullYear(), 'from');
    changeMonth(fromDate.getMonth() + 1, 'from');
    changeYear(toDate.getFullYear(), 'to');
    changeMonth(toDate.getMonth() + 1, 'to');
    setIsDateChanged(true);
    const dateRange: DateRange = {
      fromYear: fromDate.getFullYear(),
      fromMonth: fromDate.getMonth() + 1,
      fromDay: fromDate.getDate(),
      toYear: toDate.getFullYear(),
      toMonth: toDate.getMonth() + 1,
      toDay: toDate.getDate()
    };
    loadSuggestionsEntriesStatsByDateRange(dateRange);
  };

  const handleViewClick = (entry: UsageTrackingEntry) => {
    setSelectedEntry(entry);
  };

  return (
    <div>
      <DateRangeSelector onDateChange={handleDateChange} />

      <br />
      
      <CategorySelector selectedCategory={selectedCategory} onCategoryChange={handleCategoryChange} />
      <SubTypeStatsList subTypeStats={subTypeStats} isLoading={loading} />

      {!loading && trackingEntries.length > 0 && <SuggestionTrackerTable 
        data={trackingEntries} 
        onViewClick={handleViewClick} 
        loadTrackingEntriesByDateRange={loadTrackingEntriesByDateRange}
        page={page}
        hasMore={hasMore}
      />}

     {selectedEntry && (
        <Modal
          open={!!selectedEntry}
          onClose={() => setSelectedEntry(null)}
          aria-labelledby="usage-tracking-modal"
          aria-describedby="usage-tracking-details"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 800,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}>
            <Typography id="usage-tracking-modal" variant="h6" component="h2" gutterBottom>
              Usage Tracking Details
            </Typography>
            {selectedEntry && (
              <>
                <Typography><strong>External Ticket ID:</strong> {selectedEntry.external_ticket_id || 'N/A'}</Typography>
                <Typography><strong>Suggestion Type:</strong> {selectedEntry.suggestion_type}</Typography>
                <Typography><strong>Suggestion Subtype:</strong> {selectedEntry.suggestion_subtype || 'N/A'}</Typography>
                <Typography><strong>Is Approved:</strong> {selectedEntry.is_approved ? 'Yes' : 'No'}</Typography>
                <Typography><strong>Is Reported Wrong:</strong> {selectedEntry.is_reported_wrong ? 'Yes' : 'No'}</Typography>
                <Typography><strong>Answer Message:</strong></Typography>
                <div style={{ marginLeft: '1rem', whiteSpace: 'pre-wrap' }}>
                  {selectedEntry.suggestion_data?.answer_message || 'N/A'}
                </div>
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
}
